module.exports = __webpack_public_path__ + "media/images/new_entry_lead_sp-20cdc5ebd308a898da0d6326c3785a6b.png";